import type { LoginPageLogic } from 'models/logic-hooks/login-logic-hook.models';
import { createContext } from 'react';

export const LoginPageContext = createContext({} as LoginPageLogic);
